'use client';

import { styled } from '@linaria/react';
import { usePinAdToBottomStore } from '@fe-news/context/pin-ad-to-bottom-zustand';
import {
  type IntersectionObserverOptions,
  useIsInteractingObserver
} from '@fe-common-utils/libs/hooks/useIsInteractingObserver';

const DEFAULT_OBSERVER_OPTIONS = { rootMargin: '0px 0px -200px 0px', threshold: 0 };

const ObserverAnchor = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  height: 1px;
  width: 1px;
  padding: 0;
  border: 0;
`;

const NewsLatestObserver = (
  props: { observerOptions?: IntersectionObserverOptions }
) => {
  const { setShowOnce } = usePinAdToBottomStore();

  const interactingObserverReference = useIsInteractingObserver(setShowOnce, (props.observerOptions || DEFAULT_OBSERVER_OPTIONS));

  return (
    <ObserverAnchor ref={interactingObserverReference} data-slot="observer-anchor">
      &nbsp;
    </ObserverAnchor>
  );
};

export default NewsLatestObserver;
